import React from 'react';
import { injectIntl } from 'react-intl';
import AdminShell, { Icon } from './AdminShell';
import COPY from '../PublicSite/copy.json';
import { GROUPS, FIGURES, hasVars } from '../../routes/site-admin/websiteContent/groups';
import { text } from './peopleCopy';

/*
 * Website content — layar `homepage` paket client, arketipe F.
 *
 * PROTOTIPE TIDAK BISA DIIKUTI DI SINI, dan alasannya bukan gaya. Prototipe
 * menampilkan daftar bagian yang bisa digeser urutannya, masing-masing dengan
 * saklar terbit. Situs publik ini tidak begitu: urutan bagiannya tetap, ditulis
 * di komponen React, dan tidak ada tabel bagian, tidak ada kolom urutan, tidak
 * ada status terbit per bagian. Yang bisa diubah dari dashboard adalah TEKS dan
 * FOTO-nya — 596 kunci dalam dua bahasa, plus delapan foto.
 *
 * Menggeser urutan bagian di sini akan jadi kontrol yang tidak menulis apa pun.
 *
 * Daftar kunci dan kelompoknya DIPAKAI ULANG dari editor yang sudah ada di
 * /siteadmin/website-content (groups.js), bukan disalin. Dua daftar kunci yang
 * harus dijaga tetap sama adalah cara paling pasti membuat salah satunya basi.
 *
 * Hanya kelompok yang sedang dibuka yang dirender: 596 textarea sekaligus
 * membuat halaman ini berat tanpa alasan.
 */

const gql = (query, variables) => fetch('/graphql', {
  method: 'post',
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  body: JSON.stringify({ query, variables }),
  credentials: 'include'
}).then(r => r.json());

const Q_GET = '{ getSiteCopy { status results { key en ar } } }';
const M_SET = `mutation ($items: [SiteCopyInput]!) {
  updateSiteCopy(items: $items) { status errorMessage }
}`;

const prefixOf = key => key.split('.')[0];

// Kunci figure disimpan di tabel yang sama dengan teks, jadi harus dikeluarkan
// dari kelompok teks — kalau tidak ia muncul sebagai kotak isian nama berkas.
const isFigureKey = key => prefixOf(key) === 'figure';

class WebsiteContent extends React.Component {
  state = {
    loading: true, open: null, override: {}, draft: {},
    saving: false, savedAt: null, error: null, uploading: null, search: ''
  };

  componentDidMount() { this.load(); }

  locale = () => this.props.intl && this.props.intl.locale;
  tx = (en, ar) => text(this.locale(), en, ar);

  load = async () => {
    const json = await gql(Q_GET).catch(() => null);
    const rows = (json && json.data && json.data.getSiteCopy
      && json.data.getSiteCopy.results) || [];
    const override = {};
    rows.forEach(r => { override[r.key] = { en: r.en || '', ar: r.ar || '' }; });
    this.setState({ override, loading: false });
  };

  keysFor = prefix => Object.keys(COPY['en-US'] || {})
    .filter(k => !isFigureKey(k) && prefixOf(k) === prefix);

  /*
   * GROUPS memberi nama manusiawi, tapi bukan daftar yang menentukan APA yang
   * tampil. Awalan yang belum sempat diberi nama tetap dirender memakai
   * awalannya sendiri — kalau tidak, teks halaman baru diam-diam tidak bisa
   * diedit sampai ada yang ingat memperbarui berkas itu. Persis itu yang
   * terjadi pada 'appp', 78 teks halaman /app yang sudah tayang.
   */
  allGroups() {
    const named = GROUPS.filter(g => this.keysFor(g.prefix).length);
    const known = GROUPS.map(g => g.prefix);
    const extra = [];
    Object.keys(COPY['en-US'] || {}).forEach(k => {
      const p = prefixOf(k);
      if (isFigureKey(k) || known.indexOf(p) >= 0 || extra.indexOf(p) >= 0) return;
      extra.push(p);
    });
    return named.concat(extra.map(p => ({ prefix: p, label: `Unnamed section: ${p}` })));
  }

  toggle = prefix => this.setState(st => ({
    open: st.open === prefix ? null : prefix,
    // Membuang draft saat berpindah kelompok: menyimpan hanya mengirim yang
    // sedang terbuka, jadi menyimpannya diam-diam akan menjanjikan lebih
    // banyak daripada yang benar-benar tersimpan.
    draft: {}, savedAt: null, error: null
  }));

  edit = (key, lang, value) => this.setState(st => {
    const base = st.draft[key] || st.override[key] || { en: '', ar: '' };
    return { draft: { ...st.draft, [key]: { ...base, [lang]: value } }, savedAt: null };
  });

  valueOf = (key, lang) => {
    const { draft, override } = this.state;
    if (draft[key] && draft[key][lang] !== undefined) return draft[key][lang];
    if (override[key]) return override[key][lang] || '';
    return '';
  };

  defaultOf = (key, lang) => (COPY[lang === 'ar' ? 'ar' : 'en-US'] || {})[key] || '';

  save = async () => {
    const { draft } = this.state;
    const items = Object.keys(draft).map(key => ({
      key, en: draft[key].en || '', ar: draft[key].ar || ''
    }));
    if (!items.length) return;

    this.setState({ saving: true, error: null });
    const json = await gql(M_SET, { items }).catch(() => null);
    const res = json && json.data && json.data.updateSiteCopy;

    if (!res || Number(res.status) !== 200) {
      this.setState({ saving: false, error: (res && res.errorMessage) || this.tx('Save failed.', 'فشل الحفظ.') });
      return;
    }

    this.setState(st => {
      const override = { ...st.override };
      items.forEach(i => {
        // Dua-duanya kosong berarti kembali ke teks bawaan: mutation menghapus
        // barisnya, jadi state lokal harus melakukan hal yang sama.
        if (!i.en.trim() && !i.ar.trim()) delete override[i.key];
        else override[i.key] = { en: i.en, ar: i.ar };
      });
      return { override, draft: {}, saving: false, savedAt: Date.now() };
    });
  };

  upload = async (slot, file) => {
    if (!file) return;
    this.setState({ uploading: slot, error: null });

    const body = new FormData();
    body.append('file', file);
    const resp = await fetch('/uploadSiteFigure', { method: 'post', body, credentials: 'include' })
      .then(r => r.json())
      .catch(() => ({ status: 400 }));

    if (Number(resp.status) !== 200) {
      this.setState({ uploading: null, error: 'Upload failed. Photos must be under 8 MB.' });
      return;
    }

    const key = `figure.${slot}`;
    await gql(M_SET, { items: [{ key, en: resp.fileName, ar: '' }] });
    this.setState(st => ({
      override: { ...st.override, [key]: { en: resp.fileName, ar: '' } },
      uploading: null, savedAt: Date.now()
    }));
  };

  resetFigure = async slot => {
    const key = `figure.${slot}`;
    await gql(M_SET, { items: [{ key, en: '', ar: '' }] });
    this.setState(st => {
      const override = { ...st.override };
      delete override[key];
      return { override, savedAt: Date.now() };
    });
  };

  renderRow(key) {
    const { override, draft } = this.state;
    const enDefault = this.defaultOf(key, 'en');
    const arDefault = this.defaultOf(key, 'ar');
    const changed = !!draft[key];
    const custom = !!override[key];
    const vars = hasVars(enDefault);
    const t = this.tx;

    return (
      <div className="fieldset" key={key} style={{ marginTop: 'var(--sp-4)' }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap'
        }}>
          <span className="mono" style={{ fontSize: 'var(--fs-xs)' }}>{key}</span>
          {custom && <span className="tag amber"><i />{t('Customised', 'مخصص')}</span>}
          {changed && <span className="tag warn"><i />{t('Unsaved', 'غير محفوظ')}</span>}
          {/* Placeholder seperti {phone} atau {n} diganti saat halaman dirender.
              Menghapusnya membuat kalimat kehilangan angka atau nomornya. */}
          {vars && <span className="tag danger"><i />{t('Keeps a placeholder', 'يحافظ على عنصر نائب')}</span>}
        </div>

        <div className="form-grid">
          <div className="field">
            <label>{t('English', 'الإنجليزية')}</label>
            <textarea className="inp" rows={2}
              value={this.valueOf(key, 'en')} placeholder={enDefault}
              onChange={e => this.edit(key, 'en', e.target.value)} />
            <span className="hint">
              {enDefault ? `${t('Default', 'الافتراضي')}: ${enDefault}` : t('No default text', 'لا يوجد نص افتراضي')}
            </span>
          </div>
          <div className="field">
            <label>{t('Arabic', 'العربية')}</label>
            <textarea className="inp" rows={2} dir="rtl"
              value={this.valueOf(key, 'ar')} placeholder={arDefault}
              onChange={e => this.edit(key, 'ar', e.target.value)} />
            <span className="hint">
              {arDefault ? `${t('Default', 'الافتراضي')}: ${arDefault}` : t('No Arabic default', 'لا يوجد نص عربي افتراضي')}
            </span>
          </div>
        </div>
      </div>
    );
  }

  renderGroup(prefix, label) {
    const { open, override, draft, saving, savedAt, error, search } = this.state;
    let keys = this.keysFor(prefix);
    if (!keys.length) return null;

    const customised = keys.filter(k => override[k]).length;
    const isOpen = open === prefix;

    if (isOpen && search.trim()) {
      const q = search.trim().toLowerCase();
      keys = keys.filter(k =>
        k.toLowerCase().indexOf(q) >= 0
        || String(this.defaultOf(k, 'en')).toLowerCase().indexOf(q) >= 0);
    }

    const pending = Object.keys(draft).length;
    const t = this.tx;

    return (
      <section className="card" key={prefix} style={{ marginBottom: 'var(--sp-3)' }}>
        <button type="button" onClick={() => this.toggle(prefix)}
          aria-expanded={String(isOpen)}
          style={{
            width: '100%', display: 'flex', alignItems: 'center', gap: 'var(--sp-3)',
            padding: 'var(--sp-4) var(--sp-5)', background: 'none', border: 0,
            font: 'inherit', color: 'inherit', cursor: 'pointer', textAlign: 'start'
          }}>
          {/* Tidak ada chevron menghadap bawah di set ikonnya, jadi yang
              menghadap kanan diputar — tertutup menunjuk ke kanan, terbuka
              menunjuk ke bawah. */}
          <span style={{
            display: 'inline-flex', transition: 'transform var(--t-fast)',
            transform: isOpen ? 'rotate(90deg)' : 'none'
          }}>
            <Icon name="chevR" />
          </span>
          <b style={{ flex: 1 }}>{label}</b>
          <span className="muted" style={{ fontSize: 'var(--fs-xs)' }}>
            {this.keysFor(prefix).length} {t('text', 'نص')}{this.keysFor(prefix).length === 1 ? '' : t('s', 'وصوص')}
          </span>
          {customised > 0 && <span className="tag amber"><i />{customised} {t('customised', 'مخصص')}</span>}
        </button>

        {isOpen && (
          <div className="card-b" style={{ paddingTop: 0 }}>
            {error && (
              <div className="notice danger">
                <span className="ni">!</span><span className="nt">{error}</span>
              </div>
            )}
            {keys.length === 0
              ? <p className="muted">{t('Nothing in this section matches the search.', 'لا يوجد شيء في هذا القسم يطابق البحث.')}</p>
              : keys.map(k => this.renderRow(k))}

            <div className="form-actions" style={{ marginTop: 'var(--sp-4)' }}>
              <span className="sp">
                {savedAt
                  ? t('Saved. The site picks the change up within a minute.', 'تم الحفظ. سيظهر التغيير على الموقع خلال دقيقة.')
                  : pending
                    ? `${pending} ${t('text changed', 'نص تم تغييره')}`
                    : t('Leave a field blank to fall back to the default wording', 'اترك الحقل فارغاً للعودة إلى النص الافتراضي')}
              </span>
              <button className="btn" type="button" onClick={this.save}
                disabled={!pending || saving}>
                <Icon name="check" />{saving ? t('Saving…', 'جارٍ الحفظ…') : t('Save this section', 'حفظ هذا القسم')}
              </button>
            </div>
          </div>
        )}
      </section>
    );
  }

  renderFigures() {
    const { override, uploading } = this.state;
    const t = this.tx;

    return (
      <section className="card" style={{ marginBottom: 'var(--sp-3)' }}>
        <div className="card-b">
          <h3 style={{
            fontSize: 'var(--fs-xs)', fontWeight: 700, letterSpacing: '.11em',
            textTransform: 'uppercase', color: 'var(--brand-amber)',
            marginBottom: 'var(--sp-1)'
          }}>{t('Photos', 'الصور')}</h3>
          <p style={{ fontSize: 'var(--fs-xs)', color: 'var(--tx-3)', marginBottom: 'var(--sp-4)' }}>
            {t('One photo per page. Uploads are resized automatically; anything over 8 MB is refused. The coverage page is not here — it draws a map, not a photo.', 'صورة واحدة لكل صفحة. يتم تغيير حجم الصور تلقائياً، ويُرفض ما يتجاوز 8 ميغابايت. صفحة التغطية غير موجودة هنا لأنها تعرض خريطة لا صورة.')}
          </p>

          <div className="form-grid">
            {FIGURES.map(f => {
              const key = `figure.${f.slot}`;
              const custom = override[key] && override[key].en;
              return (
                <div className="field" key={f.slot}>
                  <label>{f.label}</label>
                  <div style={{
                    display: 'flex', alignItems: 'center', gap: 'var(--sp-3)', flexWrap: 'wrap'
                  }}>
                    <span className={`tag ${custom ? 'amber' : ''}`}>
                      <i />{custom ? t('Custom photo', 'صورة مخصصة') : t('Default photo', 'الصورة الافتراضية')}
                    </span>
                    <label className="btn ghost sm" style={{ cursor: 'pointer' }}>
                      <Icon name="image" />
                      {uploading === f.slot ? t('Uploading…', 'جارٍ الرفع…') : t('Replace', 'استبدال')}
                      <input type="file" accept="image/*" style={{ display: 'none' }}
                        disabled={!!uploading}
                        onChange={e => this.upload(f.slot, e.target.files && e.target.files[0])} />
                    </label>
                    {custom && (
                      <button className="btn ghost sm" type="button"
                        onClick={() => this.resetFigure(f.slot)}>{t('Use default', 'استخدام الافتراضي')}</button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    );
  }

  render() {
    const { loading, error, override, search, savedAt } = this.state;
    const totalKeys = Object.keys(COPY['en-US'] || {}).filter(k => !isFigureKey(k)).length;
    const customised = Object.keys(override).filter(k => !isFigureKey(k)).length;
    const t = this.tx;

    return (
      <AdminShell
        current="website"
        breadcrumb={[t('Content', 'المحتوى'), t('Website content', 'محتوى الموقع')]}
        title={t('Website content', 'محتوى الموقع')}
        lead={this.locale() === 'ar' ? `${totalKeys} نصاً في الموقع العام بالإنجليزية والعربية. ${customised} مخصص والباقي يستخدم النص المدمج.` : `${totalKeys} pieces of text across the public site, English and Arabic. ${customised} customised, the rest use the built-in wording.`}
        actions={[
          <a className="btn ghost" href="/siteadmin/website-content" key="c">{t('Open in classic', 'فتح النسخة الكلاسيكية')}</a>,
          <a className="btn ghost" href="/" target="_blank" rel="noopener noreferrer" key="p">
            <Icon name="eye" />{t('Preview site', 'معاينة الموقع')}
          </a>
        ]}
      >
        {/* Prototipe menampilkan daftar bagian yang bisa digeser dan diterbitkan
            satu per satu. Situs ini tidak punya tabel bagian, kolom urutan, atau
            status terbit — urutannya tetap di dalam komponen React. Disebutkan
            di sini supaya bedanya tidak terbaca sebagai fitur yang tertinggal. */}
        <div className="notice">
          <span className="ni">i</span>
          <span className="nt">
            {t('The order of the sections on the site is fixed in the page templates and cannot be changed here. What this screen edits is the wording and the photos. Clear a field to fall back to the built-in text.', 'ترتيب الأقسام ثابت في قوالب الصفحات ولا يمكن تغييره هنا. تعدل هذه الشاشة النصوص والصور. اترك الحقل فارغاً للعودة إلى النص المدمج.')}
          </span>
        </div>

        {error && !loading && (
          <div className="notice danger">
            <span className="ni">!</span><span className="nt">{error}</span>
          </div>
        )}

        {savedAt && (
          <div className="notice">
            <span className="ni">✓</span>
            <span className="nt">{t('Saved. The public site caches copy for a minute, so the change appears shortly.', 'تم الحفظ. يحتفظ الموقع العام بالنص مؤقتاً لدقيقة، وسيظهر التغيير قريباً.')}</span>
          </div>
        )}

        {loading
          ? <section className="card"><div className="card-b">{t('Loading…', 'جارٍ التحميل…')}</div></section>
          : (
            <div>
              <section className="card" style={{ marginBottom: 'var(--sp-3)' }}>
                <div className="toolbar">
                  <div className="search">
                    <svg viewBox="0 0 24 24">
                      <circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" />
                    </svg>
                    <input className="inp" value={search}
                      placeholder={t('Search within the open section', 'ابحث داخل القسم المفتوح')}
                      aria-label={t('Search within the open section', 'ابحث داخل القسم المفتوح')}
                      onChange={e => this.setState({ search: e.target.value })} />
                  </div>
                </div>
              </section>

              {this.renderFigures()}
              {this.allGroups().map(g => this.renderGroup(g.prefix, g.label))}
            </div>
          )}
      </AdminShell>
    );
  }
}

export default injectIntl(WebsiteContent);
